module.exports = __webpack_public_path__ + "img/menu-hair-12.fed8cc08.jpg";